import { useState } from 'react';

/**
 * Gives a component a way to force itself to re-render on demand.
 * Keeps a throwaway counter in state and returns a function that increments it.
 *
 * @returns A function that triggers a re-render when called.
 */
export default function useForceRerender() {
  const [, setValue] = useState(0);

  return () => setValue((value) => value + 1);
}
